// extracted by mini-css-extract-plugin
export var accordion = "_ap-0";
export var chevron = "_ap-3";
export var closed = "_ap-2";
export var content = "_ap-4";
export var open = "_ap-1";
export var rotate = "_ap-5";